export const style = {
  clearInsight: {
    sx: {
      color: 'action.active',
      opacity: 0.8,
      ml: 1.5,
      '& :hover': {
        cursor: 'pointer',
      },
    },
  },
  boxRowMl: {
    ml: 1,
    mr: 0,
  },
  boxRowLabel: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
  },
  viewModeBoxRowLabel: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 0,
  },
  boxRow: {
    display: 'flex',
    gap: '10px',
    marginBottom: '10px',
    alignItems: 'center',
  },
} as const;
